import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import moment from "moment-timezone"
import { createGlobalStyle } from 'styled-components'
import 'antd/dist/antd.css'
import './app.css';

import { store } from './effects/store'
import App from './app'
import * as serviceWorker from './serviceWorker';

moment.tz.setDefault("America/Los_Angeles");

const GlobalStyle = createGlobalStyle`
  body {
    background: #f1f2f5;
  }
`

ReactDOM.render(
  <>
    <GlobalStyle />
    <Router>
      <Provider store={store}>
        <App />
      </Provider>
    </Router>
  </>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
